import { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import About from './components/About';
import Services from './components/Services';
import Products from './components/Products';
import Contact from './components/Contact';
import Footer from './components/Footer';
import AIChat from './components/AIChat';
import { Section } from './types';

function App() {
  const [currentSection, setCurrentSection] = useState<Section>(Section.HOME);

  // Handle scroll spy to update active section in Navbar
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + 100; // Offset

      const sections = Object.values(Section);
      
      for (const section of sections) {
        if (section === Section.HOME) continue; 
        
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setCurrentSection(section);
            return;
          }
        }
      }
      
      // If at top, set to Home
      if (window.scrollY < 200) {
        setCurrentSection(Section.HOME);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavigate = (section: Section) => {
    setCurrentSection(section);
    if (section === Section.HOME) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(section);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  return (
    <div className="bg-simios-dark min-h-screen text-slate-100 font-sans selection:bg-simios-accent selection:text-white">
      <Navbar currentSection={currentSection} onNavigate={handleNavigate} />
      
      <main className="relative">
        <Hero onCtaClick={() => handleNavigate(Section.SERVICES)} />
        <About />
        <Services />
        <Products />
        <Contact />
      </main>

      <Footer />
      <AIChat />
    </div>
  );
}

export default App;